import styled, { themeGet, device, color } from '@styled'
import { Link } from 'gatsby'

export const ServicesWrapper = styled.section`
  padding-block-start: 60px;
  padding-block-end: 20px;
  ${device.medium} {
    padding-block-start: 80px;
  }
  ${device.large} {
    padding-block-start: 100px;
  }
  ${color}
`

export const InfoCircle = styled(Link)`
  @keyframes myfirst {
    0% {
      opacity: 0;
      margin-right: 0px;
    }
    100% {
      opacity: 1;
      margin-right: 10%;
    }
  }
  will-change: opacity, margin-right;
  display: block;
  animation: myfirst 3s;
  position: absolute;
  width: 106px;
  height: 106px;
  font-size: 11px;
  border-radius: 50%;
  background: ${themeGet('colors.secondary')};
  right: 0;
  top: 0;
  cursor: ${(props) => (props.href || props.to ? 'pointer' : 'default')};
  margin-right: 10%;
  margin-top: -53px;
  :hover {
    background: ${(props) =>
      props.href || props.to
        ? 'rgba(192,115,79)'
        : themeGet('colors.secondary')};
  }
  ${device.small} {
    font-size: 13px;
    width: 118px;
    height: 118px;
    margin-top: -59px;
  }
  ${device.medium} {
    font-size: 16px;
    width: 150px;
    height: 150px;
    margin-top: -75px;
  }
  ${device.large} {
    font-size: 20px;
    width: 200px;
    height: 200px;
    margin-top: -100px;
  }
`

export const InfoCircleText = styled.div`
  text-align: center;
  color: white;
  position: absolute;
  width: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`

export const InnerSection = styled.section`
  margin-bottom: 60px;
  background: ${themeGet('colors.secondaryBg')};
  ${color}
`

export const SectionBottom = styled.div`
  margin-block-start: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  ${device.small} {
    flex-direction: row;
  }
`

export const GridWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 20px;
  margin-bottom: 20px;
`

export const Grid = styled.div`
  max-width: 100%;
  flex-basis: 100%;
  padding-block: 20px;
  padding-inline: 10px;
  position: relative;
  ${device.medium} {
    max-width: 50%;
    flex-basis: 50%;
  }
  ${device.large} {
    padding-block: 60px;
    max-width: 33%;
    flex-basis: 33%;
  }
  ${device.xlarge} {
    padding-block: 60px;
    padding-inline: 25px;
  }
`

export const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;

  & .swiper-button-prev::after,
  & .swiper-rtl .swiper-button-next::after {
    content: '' !important;
  }
  ${device.xsmall} {
    height: 350px;
    gatsby-image-wrapper,
    img {
      max-height: 300px;
    }
  }
  ${device.medium} {
    padding-left: 50px;
    padding-right: 50px;
    height: 400px;
    gatsby-image-wrapper,
    img {
      max-height: 350px;
    }
  }
  ${device.large} {
    height: 550px;
    gatsby-image-wrapper,
    img {
      max-height: 500px;
    }
  }
  ${device.xlarge} {
    height: 650px;
    gatsby-image-wrapper,
    img {
      max-height: 600px;
    }
  }
`

export const ImageLink = styled(Link)`
  cursor: ${(props) => (props.href || props.to ? 'pointer' : 'default')};
`

export const SwiperWrapper = styled.div`
  & .swiper-button-prev::after,
  & .swiper-rtl .swiper-button-next::after {
    content: '';
  }

  & .swiper-button-next::after,
  & .swiper-rtl .swiper-button-prev::after {
    content: '';
  }

  & .swiper-slide {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  ${device.xsmall} {
    height: 350px;
  }
  ${device.medium} {
    height: 400px;
  }
  ${device.large} {
    height: 550px;
  }
  ${device.xlarge} {
    height: 650px;
  }
`
